import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import LoginModal from '../../components/navigation/LoginModal';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import ForgotPasswordModal from '../../components/navigation/ForgotPasswordModal';
import DashboardHeaderLanding from 'components/navigation/DashboardHeaderLanding';


const LandingAuthentication = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  // 1. POPRAVKA: Dodat state koji je nedostajao
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isForgotOpen, setIsForgotOpen] = useState(false);
  const [modalMode, setModalMode] = useState('login');

  const handleOpenModal = (mode) => {
    setModalMode(mode);
    setIsModalOpen(true);
    setIsForgotOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenForgot = () => {
    setIsModalOpen(false);
    setIsForgotOpen(true);
  };

  const handleAuthSuccess = (data) => {
    // Sada varijabla postoji i neće bacati grešku
    setIsAuthenticated(true);
    const korisnikRuolo = data.ruolo; 

    setTimeout(() => {
      switch (korisnikRuolo) {
        case 'superAdmin':
          navigate('/home-dashboard');
          break;
        case 'Owner':
        case 'Admin':
          navigate('/home-dashboard-owner');
          break;
        case 'User':
          navigate('/home-dashboard-dipendente'); 
          break;
        case 'qrScanner':
          navigate('/qr-code-reader'); 
          break;
        default:
          navigate('/home-dashboard-dipendente');
          break;
      }
    }, 300);
  };

  return (
    <>
      <DashboardHeaderLanding />

      <Helmet>
        <title>{t('landing.seo_title')}</title>
        <meta name="description" content={t('landing.seo_description')} />
      </Helmet>

      {/* DODANO: pt-16 md:pt-24 dodaje razmak ispod headera */}
      <div className="min-h-screen bg-background pt-16 md:pt-4">
        <main role="main" className="w-full">
          <HeroSection 
            onLoginClick={() => handleOpenModal('login')}
            onRegisterClick={() => handleOpenModal('register')}
          />
          <FeaturesSection />
          <CTASection onGetStarted={() => handleOpenModal('register')} />
        </main>

        <TestimonialsSection />

       

        <footer className="w-full px-4 md:px-6 lg:px-8 py-6 md:py-8 border-t border-border bg-card">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
              <p className="text-sm md:text-base text-muted-foreground text-center md:text-left">
                © {new Date()?.getFullYear()} OrizonDesk. {t('landing.footer_rights')}
              </p>
              
              <div className="flex items-center gap-4 md:gap-6 flex-wrap justify-center">
                <Link to="/legal-page" className="text-sm md:text-base text-muted-foreground hover:text-foreground transition-colors duration-250">
                  {t('landing.footer_privacy')}
                </Link>
                <Link to="/legal-page" className="text-sm md:text-base text-muted-foreground hover:text-foreground transition-colors duration-250">
                  {t('landing.footer_terms')}
                </Link>
                <Link to="/contact" className="text-sm md:text-base text-muted-foreground hover:text-foreground transition-colors duration-250">
                  {t('landing.footer_contact')}
                </Link>
              </div>
            </div>
          </div>
        </footer>

        {/* MODALI */}
        <LoginModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onSuccess={handleAuthSuccess}
          onForgotPassword={handleOpenForgot}
        />

        <ForgotPasswordModal 
          isOpen={isForgotOpen} 
          onClose={() => setIsForgotOpen(false)} 
          onBackToLogin={() => {
            setIsForgotOpen(false);
            setIsModalOpen(true);
          }}
        />
      </div>
    </>
  );
};

export default LandingAuthentication;